import { gsap } from 'gsap'
import { log } from 'utils/Logger'

export async function jump(obj) {
  return new Promise( (resolve) => {
    const tweenIn = gsap.to(obj.scale, {
      x: 1.4, y: 1.4,
      ease: 'power3.in',
      duration: 0.5,
      onComplete: () => {
        tweenIn.kill()
        const tweenOut =  gsap.to(obj.scale, {
          x: 1, y: 1,
          ease: 'power3.out',
          duration: 0.5,
          onComplete: () => {
            tweenOut.kill()
            resolve()
          },
        })
      },
    })
  })
}
export  function triggerTween(obj, data) {
  switch (data.type) {
    case 'move': move(obj, data).then()
      break
    default:log('Trigger Tween bad type', 'WARNING')
  }
}

export  function moveIn(obj, data) {
  obj.x = data.startX
  obj.y = data.startY
  return new Promise( (resolve) => {
    const tweenIn = gsap.to(obj, {
      x: data.endX, y: data.endY,
      ease: data.easeIn,
      duration: data.durationIn,
      onComplete: () => {
        tweenIn.kill()
        resolve()
      },
    })
  })
}

export  function move(obj, data) {
  obj.x = data.startX
  obj.y = data.startY
  return new Promise( (resolve) => {
    const tweenIn = gsap.to(obj, {
      x: data.endX, y: data.endY,
      ease: data.easeIn,
      duration: data.durationIn,
      delay: data.delayIn,
      onComplete: () => {
        tweenIn.kill()
        const tweenOut =  gsap.to(obj, {
          x: data.outX, y: data.outY,
          ease: data.easeOut,
          duration: data.durationOut,
          delay: data.delayOut,
          onComplete: () => {
            tweenOut.kill()
            resolve()
          },
        })
      },
    })
  })
}

export  function showHide(obj, alpha, inTime, endTime, delay) {
  const tweenIn = gsap.to(obj, {
    alpha: alpha,
    ease: 'power3.in',
    duration: inTime,
    onComplete: () => {
      tweenIn.kill()
      const tweenOut =  gsap.to(obj, {
        alpha: 0,
        ease: 'power3.out',
        duration: endTime,
        delay: delay,
        onComplete: () => {
          tweenOut.kill()
        },
      })
    },
  })

}

export  function alpha(obj, alpha, time, delay) {
  const t = gsap.to(obj, {
    alpha: alpha,
    ease: 'power3.in',
    duration: time,
    delay: delay,
    onComplete: () => {
      t.kill()
    },
  })

}

export function makeTween(obj, config ) {

  switch (config.type) {
    case 'alphaLoop':
      alphaLoop(obj, config)
      break
    case 'scaleLoop':
      scaleLoop(obj, config)
      break
    default:
      log('config tween bad type', 'WARNING')
      break
  }
}

export  function alphaLoop(obj, config) {

  gsap.to(obj, {
    alpha: config.alpha,
    ease: config.ease,
    duration: config.duration,
    delay: config.delay,
    repeat: -1,
  })
}

export  function scaleLoop(obj, config) {
  gsap.to(obj.scale, {
    x: config.scale.x, y: config.scale.y,
    ease: config.ease,
    duration: config.duration,
    delay: config.delay,
    repeat: -1,
  })
}

export async function tint(obj)  {
  return new Promise( (resolve) => {
    obj.tint = 0x7C7C7C
    resolve()
  })
}
